import React, { useState, useEffect } from 'react';
import './PasswordGate.css';

function PasswordGate({ onUnlock }) {
    const [name, setName] = useState('');
    const [error, setError] = useState('');
    const [darkMode, setDarkMode] = useState(false);

    useEffect(() => {
        const isDark = localStorage.getItem('herbalzen_dark_mode') === 'true';
        setDarkMode(isDark);
        if (isDark) {
            document.body.classList.add('dark-mode');
        }
    }, []);

    // Check if already unlocked
    useEffect(() => {
        const unlocked = sessionStorage.getItem('herbalzen_unlocked');
        if (unlocked === 'true') {
            onUnlock();
        }
    }, [onUnlock]);

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!name.trim()) {
            setError('Please enter your name.');
            return;
        }

        sessionStorage.setItem('herbalzen_unlocked', 'true');
        sessionStorage.setItem('herbalzen_user_name', name.trim());
        onUnlock();
    };

    const toggleTheme = () => {
        const newMode = !darkMode;
        setDarkMode(newMode);
        localStorage.setItem('herbalzen_dark_mode', newMode);
        if (newMode) {
            document.body.classList.add('dark-mode');
        } else {
            document.body.classList.remove('dark-mode');
        }
    };

    return (
        <div className={`password-gate ${darkMode ? 'dark-mode' : ''}`}>
            <div className="password-card">
                <div className="logo">🍵</div>
                <h1>Tealybox Wellness Concierge</h1>
                <p className="subtitle">Herbal Tea Formula Matching Tool</p>
                <p className="test-notice">Please enter your name to start</p>

                <form onSubmit={handleSubmit}>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => {
                            setName(e.target.value);
                            setError('');
                        }}
                        placeholder="Your Name"
                        className="password-input"
                        autoFocus
                    />
                    {error && <p className="error-message">{error}</p>}
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        <button type="submit" className="unlock-button" style={{ flex: 1, margin: 0 }}>
                            Start Assessment
                        </button>
                        <button
                            type="button"
                            className="dark-mode-toggle"
                            onClick={toggleTheme}
                            style={{ position: 'static', margin: 0, width: '48px', height: '48px', flexShrink: 0 }}
                        >
                            {darkMode ? '☀️' : '🌙'}
                        </button>
                    </div>
                </form>

                <p className="help-text">
                    We will match the formula based on your needs.
                </p>
            </div>
        </div>
    );
}

export default PasswordGate;